<svg width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M4.375 10.286h-1.75a.866.866 0 0 1-.875-.857V2.57c0-.473.392-.857.875-.857h1.75A.866.866 0 0 0 5.25.857.866.866 0 0 0 4.375 0h-1.75C1.175 0 0 1.151 0 2.571V9.43C0 10.849 1.175 12 2.625 12h1.75a.866.866 0 0 0 .875-.857.866.866 0 0 0-.875-.857zm9.368-4.891-3.5-3.429a.888.888 0 0 0-1.237 0 .845.845 0 0 0 0 1.212l2.008 1.965H5.25A.865.865 0 0 0 4.375 6c0 .474.391.857.875.857h5.764L9.008 8.823a.845.845 0 0 0 0 1.212.888.888 0 0 0 1.237 0l3.5-3.429a.846.846 0 0 0-.002-1.211z" id="ch55hdtrsa"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="cf7q7so2ob" fill="currentColor">
            <use xlink:href="#ch55hdtrsa"/>
        </mask>
        <use fill="currentColor" fill-rule="nonzero" xlink:href="#ch55hdtrsa"/>
        <g mask="url(#cf7q7so2ob)" fill="currentColor">
            <path d="M-3.429-1.029h20.857v13.714H-3.429z"/>
        </g>
    </g>
</svg>
